import WorkFeeScheduleCategoryAPIResponse from "work/values/fee-schedule-category/api/response-contracts/work-fee-schedule-category-api-response";
import FeeSchedule from "work/values/fee-schedule/fee-schedule";
import { MaskedFeeSchedule } from "../../../../entities/work-agreement/work-agreement";

export default class WorkFeeScheduleAPIResponse {
  name?: string;
  isMasked?: boolean;
  categories?: WorkFeeScheduleCategoryAPIResponse[] = [];

  deserialize(): FeeSchedule | MaskedFeeSchedule {
    if (this.isMasked) {
      return new MaskedFeeSchedule();
    }
    return new FeeSchedule(
      this.categories?.map(category => Object.assign(
        new WorkFeeScheduleCategoryAPIResponse(),
        category
      ).deserialize()) ?? [],
      this.name
    );
  }
}
